import React, { useCallback, useMemo } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { useAppContext } from '../context/AppContext';
import getInputGroupings from '../Scripts/_getInputGroupings';

const VerticalStepper_GroupAnalysis = () => {
  const {
    currentProgram,
    INPUT_SETTINGS,
    athlete,
    activeStep,
    setActiveStep,
    activeTest,
    setActiveTest
  } = useAppContext();

  const program = useMemo(() => {
    if (athlete) return athlete.program;
    if (currentProgram !== "All") return `${currentProgram} ATHlete`;
    return currentProgram;
  }, [athlete, currentProgram]);

  const testGrouping = useMemo(() => getInputGroupings('Gold', program, false, "group"), [program]);
  const inputTags    = useMemo(() => testGrouping ? testGrouping[activeStep]?.inputTags : [], [testGrouping, activeStep]);

  const handleStepClick = useCallback((index) => {
    setActiveStep(index);
  }, [setActiveStep]);

  const handleTestClick = useCallback((index) => {
    setActiveTest(index);
  }, [setActiveTest]);

  const steps = useMemo(() => testGrouping ? testGrouping.map(group => group.groupName) : [], [testGrouping]);

  const testList = useMemo(() => inputTags ? inputTags.map(tag => {
    const inputSetting = INPUT_SETTINGS.find(setting => setting.tag === tag);
    return inputSetting ? inputSetting.inputStringName : tag;
  }) : [], [inputTags, INPUT_SETTINGS]);
  
  return (
    <div style={{display: 'flex', flexDirection: 'row'}}>
      <div>
        <Stepper 
          activeStep={activeStep <= steps.length ? activeStep : 1} 
          orientation="vertical"
        >
          {steps.map((label, index) => (
            <Step 
              style={{cursor:'pointer'}}
              key={label} 
              onClick={() => handleStepClick(index)}
              completed={false}
              disabled={false}
            >
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div>
        <Stepper 
          activeStep={activeTest <= testList.length ? activeTest : 0} 
          orientation="vertical"
        >
          {testList.map((label, index) => (
            <Step 
              style={{cursor:'pointer'}}
              key={label} 
              onClick={() => handleTestClick(index)}
              completed={false}
              disabled={false}
            >
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};

export default VerticalStepper_GroupAnalysis;